import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';
import { P0003600ProgrammeFiltrationAuto } from '../../../Enum/P0003600ProgrammeFiltrationAuto';

@Component({
  selector: 'app-p0003600-card-filtration-statut',
  templateUrl: './p0003600-card-filtration-statut.component.html',
  styleUrls: ['./p0003600-card-filtration-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P0003600CardFiltrationStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P0003600.card.state.filtration.status.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003600.card.state.filtration.status.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P0003600.card.state.filtration.status.auto',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.FILTRATION_STANDARD,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.filtration'),
    );
  }

  protected readonly P0003600ProgrammeFiltrationAuto =
    P0003600ProgrammeFiltrationAuto;
}
